export default __webpack_public_path__ + "static/Paris-2024-banner-4d7a602b54ca200bd3bfb2dc5f140005.webp";